/* eslint-disable react/jsx-props-no-spreading */
import { Component } from 'react'
import PropTypes from 'prop-types'

import { COLOURS } from 'resources'

import { Container, Text, StyledCheckbox } from './styles'

export class CustomCheckBox extends Component {
  setChecked = () => {
    const { isChecked, setChecked } = this.props
    const newValue = !isChecked
    setChecked(newValue)
  }

  render() {
    const { label, editable, isChecked, borderColour, checkColour } = this.props
    return (
      <Container>
        <StyledCheckbox
          sx={{
            color: borderColour || COLOURS.intakeSurveyCheckboxOutline,
            '&.Mui-checked': {
              color: checkColour || COLOURS.turquoise1,
            },
          }}
          checked={isChecked}
          onChange={this.setChecked}
          disabled={!editable}
        />
        <Text>{label}</Text>
      </Container>
    )
  }
}

CustomCheckBox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
  editable: PropTypes.bool.isRequired,
  borderColour: PropTypes.string,
  checkColour: PropTypes.string,
}

export default CustomCheckBox
